// @flow
import createAction, { createOptimisticAction } from 'Store/utils/createAction';
import {
  fetchPriceOfStay,
  type PriceOfStayCriteria,
} from 'Store/price-remote/price-of-stay/priceOfStay.helper';
import { PRICE_OF_STAY_REQUEST, RESET_PRICE_OF_STAY } from 'Store/price-remote/constants';

export const getPriceOfStay = (appContext: AppContext, searchCriteria: PriceOfStayCriteria) => {
  return createOptimisticAction(
    PRICE_OF_STAY_REQUEST,
    {},
    {
      optimist: true,
      promise: fetchPriceOfStay(appContext, searchCriteria),
    },
  );
};

export const resetPriceOfStay = () => createAction(RESET_PRICE_OF_STAY);
